/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
 */
export interface OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo {
    /**
     * 商品ID
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    id?: number;
    /**
     * 是否合包商品 0 否 1 是
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    combined?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    code?: string;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    imgUrl?: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    name?: string;
    /**
     * 商品颜色
     * @type {string}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    color?: string;
    /**
     * 商品尺寸
     * @type {string}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    size?: string;
    /**
     * 商品数量
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    quantity?: number;
    /**
     * 构成
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    constructCount?: number;
    /**
     * 市场商品名称
     * @type {string}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    marketProNm?: string;
    /**
     * 市场选项名称
     * @type {string}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    marketOptionName?: string;
    /**
     * 父商品ID
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    parentGoodsId?: number;
    /**
     * SKU ID
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    skuId?: number;
    /**
     * SKU编码
     * @type {string}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    skuCode?: string;
    /**
     * 是否样品商品 0 不是 1 是
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    simple?: number;
    /**
     * 是否有样品商品 0 没有 1 有
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    hasSimpleGoods?: number;
    /**
     * 样品商品数量
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    simpleGoodsNumber?: number;
    /**
     * 商品来源类型 1 普通url下单 2 sku下单 3 库存下单 4 复制购物车
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    sourceType?: number;
    /**
     * 快递运单号列表
     * @type {Array<string>}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    parcelTrackingNumbers?: Array<string>;
    /**
     * 货位号列表
     * @type {Array<string>}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    locationNos?: Array<string>;
    /**
     * 子商品列表
     * @type {Array<OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo>}
     * @memberof OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo
     */
    children?: Array<OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo>;
}

/**
 * Check if a given object implements the OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo interface.
 */
export function instanceOfOrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo(value: object): value is OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo {
    return true;
}

export function OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoFromJSON(json: any): OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo {
    return OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoFromJSONTyped(json, false);
}

export function OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'combined': json['combined'] == null ? undefined : json['combined'],
        'code': json['code'] == null ? undefined : json['code'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'name': json['name'] == null ? undefined : json['name'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'constructCount': json['constructCount'] == null ? undefined : json['constructCount'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'parentGoodsId': json['parentGoodsId'] == null ? undefined : json['parentGoodsId'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'simple': json['simple'] == null ? undefined : json['simple'],
        'hasSimpleGoods': json['hasSimpleGoods'] == null ? undefined : json['hasSimpleGoods'],
        'simpleGoodsNumber': json['simpleGoodsNumber'] == null ? undefined : json['simpleGoodsNumber'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'parcelTrackingNumbers': json['parcelTrackingNumbers'] == null ? undefined : json['parcelTrackingNumbers'],
        'locationNos': json['locationNos'] == null ? undefined : json['locationNos'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoFromJSON)),
    };
}

export function OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoToJSON(json: any): OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo {
    return OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoToJSONTyped(json, false);
}

export function OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoToJSONTyped(value?: OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'combined': value['combined'],
        'code': value['code'],
        'imgUrl': value['imgUrl'],
        'name': value['name'],
        'color': value['color'],
        'size': value['size'],
        'quantity': value['quantity'],
        'constructCount': value['constructCount'],
        'marketProNm': value['marketProNm'],
        'marketOptionName': value['marketOptionName'],
        'parentGoodsId': value['parentGoodsId'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'simple': value['simple'],
        'hasSimpleGoods': value['hasSimpleGoods'],
        'simpleGoodsNumber': value['simpleGoodsNumber'],
        'sourceType': value['sourceType'],
        'parcelTrackingNumbers': value['parcelTrackingNumbers'],
        'locationNos': value['locationNos'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoToJSON)),
    };
}

